<template>
    <div class="register">
        <div class="img">
            <img src="../assets/login-bg.png" alt />
        </div>
        <div class="login-container">
            <el-form ref="ruleForm" status-icon :model="ruleForm" label-width="0px" :rules="rules">
                <el-form-item label prop="email">
                    <el-input v-model="ruleForm.email" placeholder="请输入email"></el-input>
                </el-form-item>
                <el-form-item label prop="password">
                    <el-input v-model="ruleForm.password" type="password" placeholder="请输入登陆密码"></el-input>
                </el-form-item>
                <el-form-item label prop="checkPass">
                    <el-input v-model="ruleForm.checkPass" type="password" placeholder="请再次输入密码"></el-input>
                </el-form-item>
                <el-form-item label prop="realName">
                    <el-input v-model="ruleForm.realName" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
                <el-form-item label prop="userPhone">
                    <el-input v-model="ruleForm.userPhone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label prop="companyName">
                    <el-input v-model="ruleForm.companyName" placeholder="请输入单位名称"></el-input>
                </el-form-item>
            </el-form>
            <button style="cursor: pointer" @click="onSubmitValidate()">注册</button>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/login';

export default {
    name: 'register',
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            checked: false,
            ruleForm: {
                email: '',
                password: '',
                checkPass: '',
                realName: '',
                userPhone: '',
                companyName: '',
            },
            rules: {
                email: [{ required: true, message: '请输入email地址', trigger: 'blur' }],
                password: [
                    {
                        required: true,
                        validator: validatePass,
                        message: '请输入密码',
                        trigger: 'blur',
                    },
                ],
                checkPass: [
                    {
                        required: true,
                        validator: validatePass2,
                        message: '两次输入密码不一致!',
                        trigger: 'blur',
                    },
                ],
                realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
                userPhone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
                companyName: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
            },
        };
    },
    methods: {
        onSubmitValidate() {
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    this.onSubmit();
                } else {
                    return false;
                }
            });
        },
        onSubmit() {
            const params = { ...this.ruleForm };
            delete params.checkPass;
            apis.register(params).then(res => {
                this.$router.push({ path: '/login' });
            });
        },
    },
};
</script>

<style lang="less" scoped>
.register {
    width: 1200px;
    height: 750px;
    background-color: #ffffff;
    box-shadow: 0px 0px 30px 0px rgba(169, 169, 169, 0.5);
    border-radius: 40px;
    margin: 60px auto;
    display: flex;
    justify-content: space-between;
    padding: 60px 45px;
    .img {
        width: 480px;
        height: 395px;
        img {
            width: 100%;
        }
    }
    .login-container {
        width: 458px;
        /deep/.el-form-item {
            border-bottom: 1px solid #cccdd0;
            padding: 10px 0;
            .el-input {
                font-size: 16px;
            }
            .el-input__inner {
                border: 0;
            }
            .el-form-item__error {
                margin-top: 14px;
                font-size: 14px;
                margin-left: 16px;
            }
        }
        button {
            width: 200px;
            height: 50px;
            line-height: 50px;
            background-color: #3c9539;
            border-radius: 39.5px;
            color: #fff;
            font-size: 18px;
            margin: 100px auto;
            display: block;
            border: none;
            outline: none;
        }
    }
}
</style>